import { render, staticRenderFns } from "./DyoDesigns.vue?vue&type=template&id=6800805e&"
import script from "./DyoDesigns.vue?vue&type=script&lang=js&"
export * from "./DyoDesigns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports